var map = {
	"./close.png": "Rxzg",
	"./failed.png": "wFd6",
	"./success.png": "rdsG",
	"./warning.png": "Zbxd"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1dVB";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg ^\.\/.*\.png$
// module id = 1dVB
// module chunks = 0